import * as d3 from "d3";

import { useApi } from "../contexts/ApiProvider";

export var parseDate = d3.utcParse("%Y-%m-%dT%H:%M:%S");
export var formatDate = d3.timeFormat("%d %B %Y");
export var formatDateNumeric = d3.timeFormat("%Y-%m-%d");

export function parsePtObjDates(ptObj, constraints, level) {
  //console.log('ptObj', ptObj);
  var parseDate = d3.utcParse("%Y-%m-%dT%H:%M:%S");

  var data = { pt: {}, locations: [], source_list: [], tests: [] };
  var temp_source_list = [];

  const ptDates = [
    "adm_start",
    "at_risk_start",
    "at_risk_end",
    "inf_start",
    "inf_end",
    "plot_start",
    "plot_end",
  ];
  const sourceDates = [
    "at_risk_start",
    "at_risk_end",
    "inf_start",
    "inf_end",
    "collectdt",
    "ward_start",
    "ward_end",
  ];

  // PATIENT DATA

  for (let i = 0; i < ptDates.length; i++) {
    const key = ptDates[i];
    Object.assign(data.pt, { [key]: parseDate(ptObj.pt[key]) });
  }
  Object.assign(data.pt, {
    name: ptObj.pt.name,
    hospital_number: ptObj.pt.hospital_number,
    day_adm_first_positive: ptObj.pt.day_adm_first_positive,
    ward_first_positive: ptObj.pt.ward_first_positive,
    first_positive: ptObj.pt.first_positive,
    gender: ptObj.gender,
    dob: ptObj.pt.dob,
  });

  // SOURCE LIST

  ptObj.source_list.forEach(function (d) {
    let ward_obj = {};
    Object.assign(ward_obj, { ward: d.ward });

    let sources_arr = [];
    d.sources.forEach(function (di) {
      let sources_obj = {};
      for (let i = 0; i < sourceDates.length; i++) {
        const key = sourceDates[i];
        Object.assign(sources_obj, { [key]: parseDate(di[key]) });
      }

      Object.assign(sources_obj, {
        firstname: di.firstname,
        surname: di.surname,
        hospital: di.hospital,
        hospital_number: di.hospital_number,
        pid: di.pid,
        seq_id: di.seq_id,
        micro_id: di.micro_id,
        specialty: di.specialty,
        ward: di.ward,
        label: di.firstname + " " + di.surname + ", " + di.hospital_number,

        risk_bar_start: Math.max(
          parseDate(di.at_risk_start),
          parseDate(di.ward_start),
          parseDate(ptObj.pt.plot_start)
        ),
        risk_bar_end: Math.min(
          parseDate(di.at_risk_end),
          parseDate(di.ward_end),
          parseDate(ptObj.pt.plot_end)
        ),
        inf_bar_start: Math.max(
          parseDate(di.inf_start),
          parseDate(di.ward_start),
          parseDate(ptObj.pt.plot_start)
        ),
        // if level=ward, bar must end when srce inf ends, when srce ward stay ends, or when the idx pt leaves the ward (with an error handler)
        inf_bar_end: Math.min(
          parseDate(di.inf_end),
          parseDate(di.ward_end),
          parseDate(ptObj.pt.plot_end),
          level === "ward"
            ? ptObj.locations.find((location) => location.ward === di.ward)
              ? parseDate(
                  ptObj.locations.reduce((max, location) => {
                    if (
                      location.ward === di.ward &&
                      (!max || location.end > max.end)
                    ) {
                      return location;
                    }
                    return max;
                  }, null).end
                )
              : parseDate("2100-01-01T00:00:00")
            : parseDate("2100-01-01T00:00:00")
        ),
      });

      sources_arr.push(sources_obj);
    });
    Object.assign(ward_obj, { sources: sources_arr });
    temp_source_list.push(ward_obj);
  });

    //Filter out sources that are not present in the constraints object
    if (constraints) {
      if (constraints.length > 0) {
        temp_source_list = temp_source_list.map((ward) => {
          ward.sources = ward.sources.filter((source) => {
            return constraints.includes(source.seq_id);
          });
          return ward;
        });
      }
    }
    console.log('source_list_post', temp_source_list);
  
    // Filter out wards with no sources
    data.source_list = temp_source_list.filter(ward => ward.sources.length > 0);
    //console.log(data);
  

  // LOCATIONS
  ptObj.locations.forEach(function (d) {
    let location_obj = {};
    const start = parseDate(d.start);
    const end = parseDate(d.end);
    const adm_start = parseDate(d.adm_start);
    const adm_end = parseDate(d.adm_end);
    Object.assign(location_obj, {
      ward: d.ward,
      ward_code: d.ward_code_deduplicated,
      specialty: d.specialty,
      hospital: d.hospital,
      start: start,
      end: end,
      adm_start: adm_start,
      adm_end: adm_end,
    });

    if (start < parseDate(ptObj.pt.plot_start)) {
      Object.assign(location_obj, {
        start: parseDate(ptObj.pt.plot_start),
      });
    }
    if (end > parseDate(ptObj.pt.plot_end)) {
      Object.assign(location_obj, {
        end: parseDate(ptObj.pt.plot_end),
      });
    }
    data.locations.push(location_obj);
  });

  // TESTS
  // order of elements dictates order the circles are added to the chart
  const order = ["GDH", "Toxin"];
  var toxin_pos = [];
  ptObj.tests.forEach(function (d) {
    const obj = {
      collectdt: parseDate(d.collectdt),
      detected: d.detected,
      test_type: d.test_type,
    };
    if (d.detected === 0) {
      data.tests.unshift(obj);
    } else if (d.test_type === "GDH") {
      data.tests.push(obj);
    } else {
      toxin_pos.push(obj);
    }
  });
  data.tests = data.tests.concat(toxin_pos);

  return data;
}

export function parseGraph(graph) {
  var formatDate = d3.timeFormat("%d.%m.%Y");

  const parseNodeTuple = (tuple) => {
    if (!Array.isArray(tuple)) return null;
    const [name, id, inf_start, collectdt, seq_id] = tuple;
    const infDate = inf_start ? parseDate(inf_start) : null;
    const collectDate = collectdt ? parseDate(collectdt) : null;
    return {
      id,
      name,
      inf_start: infDate ? formatDate(infDate) : "",
      collectdt: collectDate ? formatDate(collectDate) : "",
      seq_id:
        seq_id !== null && seq_id !== undefined && seq_id !== ""
          ? String(seq_id)
          : null,
    };
  };

  const nodes = graph.edges
    .flatMap((edge) =>
      edge.map((nodeTuple) => parseNodeTuple(nodeTuple)).filter(Boolean)
    )
    .filter((node, index, self) => {
      return index === self.findIndex((n) => n.id === node.id);
    });
  var edges = [];
  for (let e = 0; e < graph.edges.length; e++) {
    edges.push({
      source: graph.edges[e][0][1],
      target: graph.edges[e][1][1],
      ward: graph.edge_features[e][0],
      duration: graph.edge_features[e][1],
      hospital: graph.edge_features[e][2],
      specialty: graph.edge_features[e][3],
    });
  }
  return { nodes, edges };
}

/* Code adapted to React component from Jason Davies */

/**
 * Newick format parser in JavaScript.
 *
 * Copyright (c) Jason Davies 2010.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 * Example tree (from http://en.wikipedia.org/wiki/Newick_format):
 *
 * +--0.1--A
 * F-----0.2-----B            +-------0.3----C
 * +------------------0.5-----E
 *                            +---------0.4------D
 *
 * Newick format:
 * (A:0.1,B:0.2,(C:0.3,D:0.4)E:0.5)F;
 *
 * Converted to JSON:
 * {
 *   name: "F",
 *   branchset: [
 *     {name: "A", length: 0.1},
 *     {name: "B", length: 0.2},
 *     {
 *       name: "E",
 *       length: 0.5,
 *       branchset: [
 *         {name: "C", length: 0.3},
 *         {name: "D", length: 0.4}
 *       ]
 *     }
 *   ]
 * }
 *
 * Converted to JSON, but with no names or lengths:
 * {
 *   branchset: [
 *     {}, {}, {
 *       branchset: [{}, {}]
 *     }
 *   ]
 * }
 */

export function parseNewick(s, name_map) {
  var ancestors = [];
  var tree = {};
  // var min_snp = null;
  var tokens = s.split(/\s*(;|\(|\)|,|:)\s*/);
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];
    var x = tokens[i - 1];
    switch (token) {
      case "(": // new branchset
        var subtree = {};
        tree.branchset = [subtree];
        ancestors.push(tree);
        tree = subtree;
        break;
      case ",": // another branch
        var subtree = {};
        ancestors[ancestors.length - 1].branchset.push(subtree);
        tree = subtree;
        break;
      case ")": // optional name next
        tree = ancestors.pop();
        break;
      case ":": // optional length next
        break;
      default:
        if (x === ")" || x === "(" || x === ",") {
          if (token in name_map) {
            var mappedValue = name_map[token];
            if (mappedValue) {
              tree.name = mappedValue[0];
              tree.collectdt = mappedValue[2];
              tree.micro_id = mappedValue[1];
              tree.seq_id = token;
            } else {
              tree.name = token + ": No data";
              tree.seq_id = token;
            }
          } else {
            tree.name = token + ": No data";
            tree.seq_id = token;
          }
          // record minimum snp distance for scale bar if there is a snp distance > 0
        } else if (x === ":") {
          tree.length = parseFloat(token);
          // if ((min_snp == null) & (tree.length !== 0)) {
          //   min_snp = tree.length;
          // } else if ((tree.length < min_snp) & (tree.length !== 0)) {
          //   min_snp = tree.length;
          // }
        }
    }
  }
  // tree["min_snp"] = min_snp;
  return tree;
}

async function FetchName(seq_id) {
  const api = useApi();
  const response = await api.get("/seq_id_to_details/" + seq_id);
  if (response.ok) {
    const result = response.body;
    return result;
  } else {
    console.log("error");
  }
}
